import React, { useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeDrawerErrors } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeAgentId() {
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().agentId ?? null)

	const { errors, isValid } = useValidatorSeeker({ agentId: dataInfo.value }, object({
		agentId: string()
			.required("Agent ID is required")
			.min(1, "Agent ID is required")
	}))

	useEffect(() => {
		autoEuropeDrawerErrors.value = { ...autoEuropeDrawerErrors.value, agentId: isValid }
	}, [JSON.stringify(errors)])

	return <TextFieldSeeker
		label="Agent ID"
		value={dataInfo.value ?? ""}
		onChange={e => setDataInfo(e.target.value, "agentId")}
		error={errors?.agentId}
	/>
}